import { handleActions } from 'redux-actions'

import { disposeConference, setParticipantIdForUser } from '../actions/conference'

const defaultState: Record<string, number> = {}

export default handleActions<Record<string, number>, any>(
  {
    [setParticipantIdForUser.toString()](state, action) {
      const typedAction = action as ReturnType<typeof setParticipantIdForUser>

      const { userId, participantId } = typedAction.payload

      return { ...state, [participantId]: userId }
    },
    [disposeConference.toString()]() {
      return defaultState
    },
  },
  defaultState
)
